var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskManagementSystems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 50,
    viewBox: "0 0 348 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6746 0.114095L3.00846 2.15757C0.776491 2.35057 0 3.80905 0 5.55703V35.8867C0 37.2481 0.483494 38.4131 1.64998 39.9701L8.1534 48.4265C9.22189 49.788 10.1934 50.08 12.2334 49.983L44.3615 48.038C47.0779 47.8445 47.8564 46.5795 47.8564 44.4416V10.3205C47.8564 9.21549 47.4199 8.89699 46.1349 7.954L37.0831 1.57208C34.9466 0.0185961 34.0731 -0.177902 30.6746 0.113595V0.114095ZM12.9598 9.76198C10.3364 9.93848 9.74138 9.97848 8.2514 8.76699L4.46345 5.75403C4.07845 5.36403 4.27195 4.87754 5.24194 4.78054L31.8381 2.83706C34.0716 2.64206 35.2346 3.42056 36.1081 4.10055L40.6695 7.40551C40.8645 7.50401 41.3495 8.0855 40.766 8.0855L13.2998 9.73898L12.9598 9.76198ZM9.90138 44.1501V15.1839C9.90138 13.9189 10.2899 13.3354 11.4529 13.2374L42.9995 11.3905C44.0695 11.294 44.553 11.974 44.553 13.2369V42.0101C44.553 43.2751 44.358 44.3451 42.6115 44.4416L12.4234 46.1915C10.6769 46.288 9.90188 45.7066 9.90188 44.1501H9.90138ZM39.701 16.7369C39.8945 17.6119 39.701 18.4869 38.826 18.5869L37.3711 18.8754V40.2616C36.1076 40.9416 34.9446 41.3301 33.9726 41.3301C32.4191 41.3301 32.0311 40.8436 30.8676 39.3866L21.3527 24.4168V38.9001L24.3627 39.5816C24.3627 39.5816 24.3627 41.3316 21.9342 41.3316L15.2393 41.7201C15.0443 41.3301 15.2393 40.3586 15.9178 40.1651L17.6663 39.6801V20.5304L15.2398 20.3339C15.0448 19.4589 15.5298 18.1954 16.8898 18.0974L24.0732 17.6139L33.9731 32.7772V19.3624L31.4496 19.0724C31.2546 18.0009 32.0311 17.2224 33.0011 17.1274L39.701 16.7369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.256 23.6L125.013 2.08437L122.856 0L106.113 16.1969L98.4564 23.6031C98.2679 23.7838 98.1175 24.0006 98.0145 24.2406C97.9114 24.4806 97.8576 24.7388 97.8564 25C97.8564 25.525 98.0721 26.0281 98.4564 26.4L113.753 41.1969L122.856 50L139.6 33.8031L139.86 33.5531L147.256 26.3969C147.445 26.2162 147.595 25.9994 147.698 25.7594C147.802 25.5194 147.855 25.2612 147.856 25C147.856 24.7383 147.802 24.4794 147.699 24.2389C147.596 23.9983 147.445 23.7811 147.256 23.6ZM122.856 32.3906L115.213 25L122.856 17.6094L130.5 25L122.856 32.3906Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.856 17.6066C121.674 16.4725 120.731 15.1126 120.084 13.6075C119.436 12.1023 119.098 10.4826 119.088 8.84414C119.087 7.20526 119.416 5.58297 120.054 4.07348C120.692 2.56399 121.627 1.19804 122.803 0.0566406L106.075 16.2285L115.178 25.0316L122.856 17.6066Z",
    fill: "url(#paint0_linear_125_388)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.519 24.9814L122.856 32.3908C124.053 33.5471 125 34.9221 125.647 36.4314C126.293 37.9373 126.626 39.5586 126.626 41.1971C126.626 42.8355 126.293 44.4568 125.647 45.9627C125 47.4721 124.053 48.8439 122.856 50.0002L139.622 33.7846L130.519 24.9814Z",
    fill: "url(#paint1_linear_125_388)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.974 0H202.739C200.043 0 197.856 2.18611 197.856 4.88281V45.1172C197.856 47.8139 200.043 50 202.739 50H242.974C245.67 50 247.856 47.8139 247.856 45.1172V4.88281C247.856 2.18611 245.67 0 242.974 0Z",
    fill: "url(#paint2_linear_125_388)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.013 6.5H228.45C227.156 6.5 226.106 7.54933 226.106 8.84375V26.0312C226.106 27.3257 227.156 28.375 228.45 28.375H239.013C240.307 28.375 241.356 27.3257 241.356 26.0312V8.84375C241.356 7.54933 240.307 6.5 239.013 6.5Z",
    fill: "#0C0C0C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.263 6.5H206.7C205.406 6.5 204.356 7.54933 204.356 8.84375V38.5312C204.356 39.8257 205.406 40.875 206.7 40.875H217.263C218.557 40.875 219.606 39.8257 219.606 38.5312V8.84375C219.606 7.54933 218.557 6.5 217.263 6.5Z",
    fill: "#0C0C0C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.982 28.251C330.977 28.251 326.108 33.1196 326.108 39.1255C326.108 45.1312 330.977 49.9998 336.982 49.9998C342.988 49.9998 347.856 45.1312 347.856 39.1255C347.856 33.1196 342.988 28.251 336.982 28.251ZM308.731 28.2519C302.725 28.2519 297.856 33.1196 297.856 39.1255C297.856 45.1312 302.725 49.9998 308.731 49.9998C314.736 49.9998 319.605 45.1312 319.605 39.1255C319.605 33.1196 314.736 28.2519 308.731 28.2519ZM333.73 14.658C333.73 20.6641 328.862 25.5331 322.857 25.5331C316.851 25.5331 311.982 20.6641 311.982 14.658C311.982 8.6532 316.851 3.78418 322.857 3.78418C328.862 3.78418 333.73 8.6532 333.73 14.658Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_388",
    x1: 121.491,
    y1: 10.1285,
    x2: 111.175,
    y2: 20.7941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_125_388",
    x1: 773.028,
    y1: 1533.18,
    x2: 1134.25,
    y2: 1291.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#78808D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_125_388",
    x1: 2697.86,
    y1: 0,
    x2: 2697.86,
    y2: 5000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9EAFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskManagementSystems);
export default __webpack_public_path__ + "static/media/task-management-systems.20a4882b97d14a4551d9d90cbcacaa73.svg";
export { ForwardRef as ReactComponent };